export default __webpack_public_path__ + "static/media/image-1.2761ec9b.png";